import axios from "axios";
const jsonConfig = require("../../Config.json");

const getRecruiterByTeam = async (Id) => {
 
    try {
        const getAllResponse = await axios.get(
          jsonConfig.apiUrl + "getRecruiterByTeam/"+ Id,
          {
            headers: {
              "x-functions-key": jsonConfig.key,
            },
          }
        );
        return Promise.resolve(getAllResponse);
      } catch (error) {
        return Promise.reject(error);
      }
}

export default getRecruiterByTeam;